import { createBrowserRouter, Navigate } from 'react-router-dom'
import { AdminLayout } from '@/layouts/admin/AdminLayout'
import { PublicLayout } from '@/layouts/public/PublicLayout'
import { RoleGate } from '@/components/shared/RoleGate'

export const router = createBrowserRouter([
  {
    path: '/',
    element: <PublicLayout />,
    children: [
      {
        index: true,
        lazy: async () => {
          const { CatalogPage } = await import('@/features/catalog/pages/CatalogPage')
          return { Component: CatalogPage }
        },
      },
      {
        path: 'productos/:id',
        lazy: async () => {
          const { ProductDetailPage } = await import('@/features/catalog/pages/ProductDetailPage')
          return { Component: ProductDetailPage }
        },
      },
    ],
  },
  {
    path: '/login',
    lazy: async () => {
      const { LoginPage } = await import('@/features/auth/LoginPage')
      return { Component: LoginPage }
    },
  },
  {
    path: '/admin',
    element: (
      <RoleGate>
        <AdminLayout />
      </RoleGate>
    ),
    children: [
      {
        index: true,
        lazy: async () => {
          const { DashboardPage } = await import('@/features/dashboard/pages/DashboardPage')
          return {
            Component: () => (
              <RoleGate role="admin">
                <DashboardPage />
              </RoleGate>
            ),
          }
        },
      },
      {
        path: 'ventas/nueva',
        lazy: async () => {
          const { RegisterSalesPage } = await import('@/features/sales/pages/RegisterSalesPage')
          return { Component: RegisterSalesPage }
        },
      },
      {
        path: 'ventas',
        lazy: async () => {
          const { SalesListPage } = await import('@/features/sales/pages/SalesListPage')
          return { Component: SalesListPage }
        },
      },
      {
        path: 'ventas/:id',
        lazy: async () => {
          const { SaleDetailPage } = await import('@/features/sales/pages/SaleDetailPage')
          return { Component: SaleDetailPage }
        },
      },
      {
        path: 'metricas',
        lazy: async () => {
          const { MetricsPage } = await import('@/features/metrics/pages/MetricsPage')
          return {
            Component: () => (
              <RoleGate role="admin">
                <MetricsPage />
              </RoleGate>
            ),
          }
        },
      },
      {
        path: 'productos',
        lazy: async () => {
          const { ProductsListPage } = await import('@/features/products/pages/ProductsListPage')
          return { Component: ProductsListPage }
        },
      },
      {
        path: 'productos/nuevo',
        lazy: async () => {
          const { ProductFormPage } = await import('@/features/products/pages/ProductFormPage')
          return { Component: ProductFormPage }
        },
      },
      {
        path: 'productos/:id/editar',
        lazy: async () => {
          const { ProductFormPage } = await import('@/features/products/pages/ProductFormPage')
          return { Component: ProductFormPage }
        },
      },
      {
        path: 'etiquetas',
        lazy: async () => {
          const { PromotionLabelsPage } = await import('@/features/products/pages/PromotionLabelsPage')
          return {
            Component: () => (
              <RoleGate role="admin">
                <PromotionLabelsPage />
              </RoleGate>
            ),
          }
        },
      },
      {
        path: 'inventario',
        lazy: async () => {
          const { InventoryPage } = await import('@/features/inventory/pages/InventoryPage')
          return { Component: InventoryPage }
        },
      },
      {
        path: 'clientes',
        lazy: async () => {
          const { CustomersPage } = await import('@/features/customers/pages/CustomersPage')
          return { Component: CustomersPage }
        },
      },
      {
        path: 'vendedoras',
        lazy: async () => {
          const { SellersPage } = await import('@/features/sellers/pages/SellersPage')
          return {
            Component: () => (
              <RoleGate role="admin">
                <SellersPage />
              </RoleGate>
            ),
          }
        },
      },
      {
        path: 'categorias',
        lazy: async () => {
          const { CategoriesPage } = await import('@/features/categories/pages/CategoriesPage')
          return {
            Component: () => (
              <RoleGate role="admin">
                <CategoriesPage />
              </RoleGate>
            ),
          }
        },
      },
      {
        path: 'banners',
        lazy: async () => {
          const { BannersPage } = await import('@/features/banners/pages/BannersPage')
          return {
            Component: () => (
              <RoleGate role="admin">
                <BannersPage />
              </RoleGate>
            ),
          }
        },
      },
      {
        path: 'configuracion',
        lazy: async () => {
          const { SettingsPage } = await import('@/features/settings/pages/SettingsPage')
          return { Component: SettingsPage }
        },
      },
    ],
  },
  {
    path: '/facturas/:id',
    lazy: async () => {
      const { InvoicePage } = await import('@/features/invoice/pages/InvoicePage')
      return { Component: InvoicePage }
    },
  },
  { path: '*', element: <Navigate to="/" replace /> },
])
